import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import OnboardingHero from '../components/onboarding/OnboardingHero';
import WhiteGloveMeans from '../components/onboarding/WhiteGloveMeans';
import OnboardingJourney from '../components/onboarding/OnboardingJourney';
import WhatWeBuild from '../components/onboarding/WhatWeBuild';
import CustomSuccessPlan from '../components/onboarding/CustomSuccessPlan';
import WhatsIncluded from '../components/onboarding/WhatsIncluded';
import OnboardingTestimonials from '../components/onboarding/OnboardingTestimonials';
import OnboardingCTA from '../components/onboarding/OnboardingCTA';

const OnboardingPage = () => {
  return (
    <div className="min-h-screen bg-gray-950">
      <Navbar />
      <OnboardingHero />
      <WhiteGloveMeans />
      <OnboardingJourney />
      <WhatWeBuild />
      <CustomSuccessPlan />
      <WhatsIncluded />
      <OnboardingTestimonials />
      <OnboardingCTA />
      <Footer />
    </div>
  );
};

export default OnboardingPage;